import { supplierState } from "../types/index"
import { supplierTableData } from "../data"

export const initialState: supplierState = {
    loading: false,
    data: supplierTableData,
    error: ""
}